import conf from '../config'
import axios from 'axios'
import { getLang, windowPath, getGeoLocation } from '../utils'

export const paymentIntegrationStatusCheckApi = async (params) => {
    console.error('🔍 paymentIntegrationStatusCheckApi called with params:', params);

    const requestConfig = {
        method: 'post',
        url: params.checkForWater ? `${conf.api.base_url}Gateway_AuthService/ViewDetail` : `${conf.api.base_url}Gateway_PostAuthPortalService/GetData`,
        data: {
            "ApiKey": params.checkForWater ? "GetWaterTransactionStatus" : "GetOnlineTransactionStatus",
            "OrgId": params.OrgId,
            "ApiParams": {
                "UniqueId": params.UniqueId,
            }
        },
        headers: {
            "Content-type": "application/json; charset=UTF-8",
            "AuthToken": params.AuthToken,
            "AuthTokenKey": params.AuthTokenKey,
            "Language": getLang(),
            "FormURL": windowPath(),
            "GeoLocation": getGeoLocation(),
        }
    };

    console.error('🌐 Making API request to:', requestConfig.url);
    console.error('📦 Request data:', requestConfig.data);
    console.error('📋 Request headers:', requestConfig.headers);

    try {
        const response = await axios(requestConfig);
        console.error('✅ API response received:', response);
        return response;
    } catch (error) {
        console.error('❌ API request failed:', error);
        console.error('❌ Error details:', error.message, error.code, error.response);
        throw error;
    }
}

export default paymentIntegrationStatusCheckApi